// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_gb","advertDetailParameterList__header":"c-q_gc","advertDetailParameterList__list":"c-q_ge"};